import Component from './index';
import reducers from './reducers';
import sagas from './sagas';
import { NAME } from './constants';

export default {
  Component: Component,
  name: NAME,
  sagas,
  reducers,
};
